

















import intlTelInput, { Iti } from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import * as utils from 'intl-tel-input/build/js/utils.js';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CountryService from '../services/CountryService';

@Component({})
export default class InternationalPhone extends Vue {
  @Prop({ required: true, type: String }) value!: string;
  @Prop({ default: false, type: Boolean }) required!: boolean;
  @Prop({ default: '' }) accessibleLabel!: string;
  public error: string = '';

  private intlTelInput: Iti;
  private input: HTMLInputElement;

  mounted() {
    this.input = this.$refs.enrichmentPhone as HTMLInputElement;
    this.input.value = this.value;

    this.intlTelInput = intlTelInput(this.input, {
      initialCountry: 'auto',
      countryOrder: ['br', 'mx', 'us'],
      countrySearch: false,
      strictMode: true,
      formatAsYouType: true,
      formatOnDisplay: true,
      nationalMode: true,
      loadUtilsOnInit: () => Promise.resolve(utils),
      geoIpLookup: (success) => CountryService.getCountryByIp().then(success),
    });
  }

  destroyed(): void {
    this.intlTelInput.destroy();
  }

  private updateError(): void {
    if (!this.intlTelInput) return;
    if (this.intlTelInput.getNumber().trim() && !this.intlTelInput.isValidNumber()) {
      this.error = 'Invalid phone number';
    } else {
      this.error = '';
    }
  }

  onInput() {
    this.$emit('input', this.intlTelInput.getNumber());
    this.updateError();
  }

  onChange() {
    this.updateError();
  }

  public validate(): boolean {
    this.$emit('input', this.intlTelInput.getNumber());
    this.updateError();
    if (this.required && !this.intlTelInput.getNumber().trim()) {
      this.error = 'Invalid phone number';
    }
    return this.error === '';
  }

  @Watch('error')
  onerrorChanged(error: string) {
    this.input.setCustomValidity(error);
  }
}
